import React, { Fragment, PureComponent } from 'react';
import { wire } from 'react-hot-wire';
import { injectIntl } from 'react-intl';
import { Formik } from 'formik';

import Info from '../../../Info';
import { schemaFactory } from './Register.schema';
import Register from './Register.template';
import { map, omit } from 'lodash';
import AuthorizeCode from 'components/auth/reset-password/integrations/imported-id/authorize-code/AuthorizeCode';
import queryString from 'query-string';
import VerifyCodeComponent from './verify-code/VerifyCode';

export class RegisterAnnoyingComponent extends PureComponent {
	state = {
		isCodeVerified: false,
		isRegisterMode: true,
	};

	render() {
		const { intl, integration, identifier } = this.props;
		const { code } = queryString.parse(window.location.search);

		return (
			<Formik
				initialValues={{
					identifier,
					authorizationCode: code || '',
					forename: '',
					surname: '',
					email: '',
					reEmail: '',
					phone: '',
					agreements: [],
				}}
				validationSchema={schemaFactory(integration, this.state.isCodeVerified)}
				onSubmit={(...args) => this.verify(...args)}
				render={props => {
					if (!this.state.isCodeVerified) {
						return <VerifyCodeComponent {...props} {...this.props} />;
					}

					if (props.status === 'email-sent') {
						return (
							<Info
								title={intl.formatMessage({
									id: 'auth.register.integration.imported-id.status.email-sent.title',
								})}
								message={intl.formatMessage({
									id: 'auth.register.integration.imported-id.status.email-sent.message',
								})}
							/>
						);
					}

					if (props.status === 'sms-sent' || !this.state.isRegisterMode) {
						return <AuthorizeCode integration={integration} identifier={props.values.identifier} />;
					}

					return (
						<Fragment>
							<Register
								{...props}
								{...this.props}
								agreements={this.props['services.applicationService'].settings().agreements()}
								ReactMarkdown={this.props['components.ReactMarkdown']}
							/>
						</Fragment>
					);
				}}
			/>
		);
	}

	componentDidMount() {
		const { code } = queryString.parse(window.location.search);

		if (code) {
			this.setState({ isCodeVerified: true });
		}
	}

	verify(values, actions) {
		const { integration } = this.props;

		actions.setStatus(null);

		if (!this.state.isCodeVerified) {
			this.props['services.importedIdIntegrationService']
				.verifyCode({
					id: integration.id,
					identifier:
						values.identifier || (integration.recommendedFlow === 'sms' ? values.phone : values.email),
					code: values.authorizationCode,
				})
				.then(response => {
					const isRegisterMode = !response;
					this.setState({ isCodeVerified: true, isRegisterMode });

					if (isRegisterMode) {
						return Promise.resolve();
					}

					return this.props['services.importedIdIntegrationService'].resetPasswordStart({
						id: integration.id,
						identifier:
							values.identifier || (integration.recommendedFlow === 'sms' ? values.phone : values.email),
						code: values.authorizationCode,
					});
				})
				.then(() => {
					actions.setSubmitting(false);
				})
				.catch(({ error }) => {
					if (
						[
							'not-allowed.annoying-integration-invalid-code',
							'token-expired-reset-token-exception',
							'attempts-limit-exceeded-reset-token-exception',
						].includes(error.messageId)
					) {
						actions.setFieldError('authorizationCode', error.messageId);
					} else {
						actions.setStatus(error.messageId);
					}

					actions.setSubmitting(false);
				});

			return;
		}

		if (!values.email && !values.phone) {
			actions.setFieldError('email', 'empty');
			actions.setFieldError('phone', 'one-of-two');
			actions.setSubmitting(false);

			return;
		}

		this.props['services.importedIdIntegrationService']
			.verify({
				id: integration.id,
				...omit(values, ['authorizationCode', 'identifier', 'agreements']),
				identifier: values.identifier || (integration.recommendedFlow === 'sms' ? values.phone : values.email),
				code: values.authorizationCode,
				agreements: map(values.agreements, id => ({ id })),
			})
			.then(response => {
				if (response === 'email') {
					actions.setStatus('email-sent');
				} else if (response === 'sms') {
					actions.setStatus('sms-sent');
				}
			})
			.catch(({ error }) => {
				const { data } = error;

				if (
					[
						'not-allowed.annoying-integration-invalid-code',
						'invalid-password-reset-token',
						'token-expired-reset-token-exception',
						'attempts-limit-exceeded-reset-token-exception',
					].includes(error)
				) {
					actions.setFieldError('authorizationCode', error);
				} else if (data.fields) {
					const { email, phone } = data.fields;

					if (email) {
						actions.setFieldError('email', `email.${email[0]}`);
					}

					if (phone) {
						actions.setFieldError('phone', `phone.${phone[0]}`);
					}
				} else {
					actions.setStatus(error.messageId);
				}

				actions.setSubmitting(false);
			});
	}
}

export default injectIntl(
	wire(
		['services.importedIdIntegrationService', 'services.applicationService', 'components.ReactMarkdown'],
		RegisterAnnoyingComponent
	)
);
